/**
 * Renminbi (Chinese) yuan.
 */
export var CNY = {
  code: 'CNY',
  base: 10,
  exponent: 2
};